import $ from 'jquery';

function initSDEKMap() {
    const $map = $('#deliverySDEK');

    $.ajax({
        url: '/sdek/pickup-points',
        method: 'GET',
        success: function(data) {
            
            if (typeof(data.pvz) === 'undefined') {
                console.error('Ошибка загрузки данных');
                return false;
            }

            try {
                if (ymaps) {
                    ymaps.ready(function() {
                        init(data.pvz)
                    });
                }
            } catch(e) {
                console.error('Ошибка карты', e);
            }

        },
        error: function() {
            $map.html('Ошибка...');
        }
    });


    function init(data) {
        // console.log('init:');
        // console.log(data);

        //setCities(data.CITY);

        const $map = $('#deliverySDEK');
        // let cityId = $('.js-sdek-city option:selected').attr('data-sdek-city-id');
        let cityId = $map.attr('data-sdek-city-id');

        if (typeof(cityId) === 'undefined') {
        cityId = 44; // Москва
        }
        $('.js-sdek-city option[data-sdek-city-id="'+cityId+'"]').addClass('_init');

        $.ajax({
            url: 'https://geocode-maps.yandex.ru/1.x/?apikey='+yandexMapApiKey+'&results=1&format=json&geocode=' + siteCity,
            method: 'GET',
            success: function(resp) {
                if (typeof resp.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos !== 'undefined') {
                    let points = resp.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
                    let city = resp.response.GeoObjectCollection.featureMember[0].GeoObject.description;

                    myMap.setZoom(12);
                    myMap.panTo([[+parseFloat(points[1]), +parseFloat(points[0])]], {flying: 1});
                    // myMap.setCenter([+parseFloat(points[1]), +parseFloat(points[0])], 14);
                }
            }
        });


        let myMap = new ymaps.Map('deliverySDEK', {
            center: [$map.data('lat'), $map.data('lng')],
            zoom: 10,
            controls: ['zoomControl'],
        });

        if ($map.hasClass('_cart')) {
        $map.addClass('_init');
        }


        // Создание макета балуна
        let MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
            '<div id="balloonPopover" class="popover _sdek top">' +
            '<a class="close" href="#">Закрыть&nbsp;<span>&times;</span></a>' +
            '<div class="arrow"></div>' +
            '<div class="popover-inner">' +
                '$[[options.contentLayout observeSize minWidth=320 maxWidth=320 maxHeight=165]]' +
            '</div>' +
            '</div>',
            {

            /**
             * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
             * @function
             * @name build
             */
            build: function () {
                this.constructor.superclass.build.call(this);
                this._$element = $('.popover', this.getParentElement());

                this.applyElementOffset();
                this._$element.find('.close')
                    .on('click', $.proxy(this.onCloseClick, this));

                this._$element.find('.js-pvz-select').on('click', function(e) {
                    e.preventDefault();
                    onPvzSelect($(this), $map);
                    return false;
                });
            },

            /**
             * Удаляет содержимое макета из DOM.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
             * @function
             * @name clear
             */
            clear: function () {
                this._$element.find('.close')
                    .off('click');

                this.constructor.superclass.clear.call(this);
            },

            /**
             * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             * @function
             * @name onSublayoutSizeChange
             */
            onSublayoutSizeChange: function () {
                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                if(!this._isElement(this._$element)) {
                    return;
                }

                this.applyElementOffset();

                this.events.fire('shapechange');
            },

            /**
             * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             * @function
             * @name applyElementOffset
             */
            applyElementOffset: function () {
                this._$element.css({
                    left: -(this._$element[0].offsetWidth / 2),
                    top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight + 20)
                });
            },

            /**
             * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             * @function
             * @name onCloseClick
             */
            onCloseClick: function (e) {
                e.preventDefault();
                this.events.fire('userclose');
            },

            /**
             * Используется для автопозиционирования (balloonAutoPan).
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
             * @function
             * @name getClientBounds
             * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
             */
            getShape: function () {
                if(!this._isElement(this._$element)) {
                    return MyBalloonLayout.superclass.getShape.call(this);
                }

                var position = this._$element.position();

                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                    [position.left, position.top], [
                        position.left + this._$element[0].offsetWidth,
                        position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                    ]
                ]));
            },

            /**
             * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
             * @function
             * @private
             * @name _isElement
             * @param {jQuery} [element] Элемент.
             * @returns {Boolean} Флаг наличия.
             */
            _isElement: function (element) {
                return element && element[0] && element.find('.arrow')[0];
            }
        });

        // Создание вложенного макета содержимого балуна.
        let MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
            '<h5 class="_title">$[properties.balloonHeader]</h5>' +
            '<div class="_content">$[properties.balloonBody]</div>' +
            `
            <div class="_footer"></div>
            `
        );



        let objectManager = new ymaps.ObjectManager({
            clusterize: true, // Чтобы метки начали кластеризоваться
            gridSize: 32,
            clusterDisableClickZoom: true,
            geoObjectOpenBalloonOnClick: true,
            clusterOpenBalloonOnClick: false
        });
        objectManager.objects.options.set({
        balloonLayout: MyBalloonLayout,
        balloonContentLayout: MyBalloonContentLayout,
        preset: 'islands#icon',
        iconColor: '#7b75c9',
        });
        objectManager.clusters.options.set({
        preset: 'islands#clusterIcon',
        iconColor: '#7b75c9',
        });

        objectManager.objects.events.add('balloonopen', function(e){
        var id = e.get('objectId'),
            geoObject = objectManager.objects.getById(id);

        if (window.innerWidth < size.tablet-1) {
            $('.js-pvz-select').on('click', function(e) {
            e.preventDefault();
            onPvzSelect($(this), $map);
            return false;
            });
        }

        });

        myMap.geoObjects.add(objectManager);


        // let markers = [];
        // for (var k in data.PVZ) {
        //   for(var key in data.PVZ[ k ]) {
        //
        //     let pvz = data.PVZ[ k ][ key ]
        //     markers.push({
        //       type: "Feature",
        //       id: key,
        //       geometry: {
        //         type: "Point",
        //         coordinates: [pvz.cY, pvz.cX],
        //       },
        //       properties: {
        //         balloonContentHeader: "Header",
        //         balloonContentBody: "Содержимое <em>балуна</em> метки",
        //         balloonContentFooter: "Подвал",
        //       }
        //     });
        //
        //   }
        // }

        let markers = getMarkers(cityId, data);

        objectManager.add({
        type: "FeatureCollection",
        features: markers
        });


        $('.js-sdek-form').on('submit', function(e) {
        e.preventDefault();
        const $city = $(this).find('.js-sdek-city');
        const $address = $(this).find('.js-sdek-address');
        let city = $city.val();
        let address = $address.val();

        if (address !== '') {
            $.ajax({
            url: 'https://geocode-maps.yandex.ru/1.x/?apikey='+yandexMapApiKey+'&results=1&format=json&geocode=' + city + ', ' + address,
            method: 'GET',
            success: function(resp) {
                if (typeof resp.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos !== 'undefined') {
                let points = resp.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
                let city = resp.response.GeoObjectCollection.featureMember[0].GeoObject.description;

                if (typeof city !== 'undefined') {
                    city = city.replace(', Россия', '');
                    let $option = $('.js-sdek-meta div[data-city="'+city+'"]')

                    if ($option.length < 1) {
                    city = resp.response.GeoObjectCollection.featureMember[0].GeoObject.name;
                    $option = $('.js-sdek-meta div[data-city="'+city+'"]')
                    }

                    if ($option.length > 0) {
                    let sdekCityId = $option.attr('data-sdek-city-id');

                    if (!$option.hasClass('_init')) {
                        markers = getMarkers(sdekCityId, data);
                        objectManager.add({
                        type: "FeatureCollection",
                        features: markers
                        });
                        $option.addClass('_init');
                    }
                    }

                }

                myMap.setZoom(14);
                myMap.panTo([[+parseFloat(points[1]), +parseFloat(points[0])]], {flying: 1});
                // myMap.setCenter([+parseFloat(points[1]), +parseFloat(points[0])], 14);
                }
            }
            });

        } else if (city !== '' && city !== undefined) {
            let $option = $city.find('option[value="'+city+'"]')
            let sdekCityId = $option.attr('data-sdek-city-id');

            myMap.panTo([[+parseFloat($option.data('lat')), +parseFloat($option.data('lng'))]], {flying: 1});

            if (typeof(sdekCityId) === 'undefined') {
            sdekCityId = 44; // Москва
            }

            if (!$option.hasClass('_init')) {
            markers = getMarkers(sdekCityId, data);
            objectManager.add({
                type: "FeatureCollection",
                features: markers
            });
            $option.addClass('_init');
            }

        }

        return false;
        });

        // $('.js-sdek-city').on('change', function(e) {
        //   let sdekCityId = $(this).attr('data-sdek-city-id');
        //   console.log($(this).val());
        // });

        const input = $('#suggest');
        let suggestView = new ymaps.SuggestView('suggest', {
            offset: [0, 10]
        });


        // let timeOut;
        // $('.js-sdek-address').on('keyup', function(e) {
        //   clearTimeout(timeOut);
        // 	timeOut = setTimeout(sdekAddress, 700, $(this).val());
        // });
        // $('.js-sdek-address').on( 'keydown', function () {
        // 	clearTimeout(timeOut);
        // });
        //
        // function sdekAddress(value) {
        //   const $input = $('.js-sdek-address');
        //   const $parent = $input.closest('.js-input-container');
        //   const $drop = $parent.find('.js-select-dropdown');
        //   const $dropList = $drop.find('ul');
        //
        //   $parent.removeClass('_open');
        //   $dropList.html('');
        //
        //   if (value.length >= 3) {
        //
        //     $.ajax({
        //       url: '/',
        //       method: 'GET',
        //       success: function(data) {
        //         let json = JSON.parse(data);
        //         console.log(json);
        //         let content = '';
        //         json.each(function() {
        //           content += `
        //             <li class="select__option-item js-sdek-address-item">
        //               <button type="button"
        //                 class="select__option-content js-option-text-input"
        //                 data-value="${item.name}"
        //                 data-lat="${item.lat}"
        //                 data-lng="${item.lng}"
        //               >${item.name}</button>
        //             </li>
        //           `;
        //         });
        //         $dropList.html(content);
        //       }
        //     });
        //
        //     $parent.addClass('_open');
        //     let scrollbar = customSelects.prototype.state.initScrollbar($parent);
        //
        //     $('.js-sdek-address-item').on('click', function(e) {
        //       e.preventDefault();
        //       const $parent = $(this).closest('.js-input-container');
        //       const $input = $parent.find('.js-sdek-address');
        //       let lat = $(this).attr('data-lat');
        //       let lng = $(this).attr('data-lng');
        //
        //       $input.val($(this).text());
        //       $parent.removeClass('_open')
        //
        //       myMap.panTo([[+parseFloat(lat), +parseFloat(lng)]], {flying: 1});
        //
        //       return false;
        //     });
        //
        //   }
        //
        // }
        //
        // $('body').on('click', function(e) {
        //   if ($('.js-input-container._sdek').length > 0) {
        //     if($(e.target).closest('.js-input-container._sdek').length < 1) {
        //       $('.js-input-container._sdek').removeClass('_open');
        //     }
        //   }
        // });


    }


    function getMarkers(cityId, data) {
        let markers = [];
        //вот тут мы поменяли чтобы не только один город был а все сразу
        for(var city in data.PVZ){
            for(var key in data.PVZ[ city ]) {
        let pvz = data.PVZ[ city ][ key ]

            //console.log(data.CITY[ cityId ]);

        markers.push({
            type: "Feature",
            id: key,
            geometry: {
            type: "Point",
            coordinates: [pvz.cY, pvz.cX],
            },
            properties: {
            balloonHeader: data.CITY[ city ] + ', '+pvz.Address,
            balloonBody: `
                <p>${pvz.AddressComment}</p>
                <p>${pvz.Phone}</p>
                <p>${pvz.WorkTime}</p>
                <div class="_actions">
                ${$map.hasClass('_cart') ? `
                    <a href="#"
                    class="btn js-pvz-select"
                    data-pvz-id="${key}"
                    data-pvz-address="${pvz.Address}"
                    data-pvz-city="${data.CITY[ city ]}"
                    >Выбрать</a>
                ` : ''}
                </div>
            `
            }
        });

        }}
        return markers;
    }

}

function setCities(cities) {
    // console.log(cities);
    const $select = $('.js-sdek-city');
    let meta = `<div class="hidden js-sdek-meta">`;


    for (var key in cities) {
        let city = cities[ key ];

        meta += `<div data-city="${city}" data-sdek-city-id="${key}">${city}</div>`

        if ($select.length > 0) {
        let $option = $select.find('option[value="'+city+'"]');

        if ($option.length > 0) {
            $option.attr('data-sdek-city-id', key);
        }

        if ($('.sdek-map[data-sdek-city-id="'+city+'"]').length > 0) {
            $('.sdek-map').attr('data-sdek-city-id', key);
        }
        }else{
            if ($('.sdek-map[data-city="'+city+'"]').length > 0) {
                $('.sdek-map').attr('data-sdek-city-id', key);
            }
        }

    }


    meta += `</div>`;
    $('.js-sdek-form').after(meta)

    let cityId = $('.js-sdek-city option:selected').attr('data-sdek-city-id');
    $('.sdek-map').attr('data-sdek-city-id', cityId);

}

function onPvzSelect($elem, $map) {
    let pvzId = $elem.data('pvz-id');
    let pvzAddress = $elem.data('pvz-address');
    let pvzCity = $elem.data('pvz-city');

    if ($map.hasClass('_cart')) {
        // плюс временно добавим ручные input-события для
        // срабатывания в React-приложении
        $('.js-cart-pvz-address').val(pvzCity + ", " + pvzAddress);
        $('.js-cart-pvz-address')[0].dispatchEvent(new Event("input", { bubbles: true }));
        $('.js-cart-pvz-id').val(pvzId);
        $('.js-cart-pvz-id')[0].dispatchEvent(new Event("input", { bubbles: true }));
        $('.js-cart-pvz-data').val(pvzAddress);
        $('.js-cart-pvz-data')[0].dispatchEvent(new Event("input", { bubbles: true }));
        $.magnificPopup.close();
    }
}

export {
    onPvzSelect,
    setCities,
    initSDEKMap
};